import { render, staticRenderFns } from "./SettingsContainer.vue?vue&type=template&id=79661c58&"
import script from "./SettingsContainer.vue?vue&type=script&lang=js&"
export * from "./SettingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79661c58')) {
      api.createRecord('79661c58', component.options)
    } else {
      api.reload('79661c58', component.options)
    }
    module.hot.accept("./SettingsContainer.vue?vue&type=template&id=79661c58&", function () {
      api.rerender('79661c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SettingsContainer.vue"
export default component.exports